import { Dialog } from 'quasar';
import { getCurrentInstance } from 'vue';

/**
 * Opens a dialog with a Vue component using Quasar Dialog plugin.
*
* @param {Object} component - Vue component definition
* @param {Object} [props] - Props to pass to the component
* @param {Function?} onOk - callback on emit 'ok'
* @param {Function?} onCancel - callback on emit 'cancel'
* @param {Function?} onDismiss - callback on emit 'dismiss'
* @param {Object} [opts] - Additional dialog options
* @returns {Object} - Dialog instance
*/
// eslint-disable-next-line import/prefer-default-export
export function useComponentDialog() {
  const vm = getCurrentInstance();

  const openComponentDialog = (component, props, onOk, onCancel, onDismiss, opts = {}) => {
    // Use Quasar Dialog plugin from globalProperties or direct import
    const dialog = (vm?.proxy?.$q?.dialog || Dialog)({
      component,
      ...opts,
      componentProps: props,
    });

    if (onOk) {
      dialog.onOk(onOk);
    }

    if (onCancel) {
      dialog.onCancel(onCancel);
    }

    if (onDismiss) {
      dialog.onDismiss(onDismiss);
    }

    return dialog;
  };

  return { openComponentDialog };
}
